import { h, FunctionComponent } from 'preact';
import { useDispatch } from 'react-redux';
import { loadDocument } from '~src/utils/documents/documents';
import { Doc } from '../enums/docs';
import LinkWrapper from './LinkWrapper';

type DocumentLinkProps = {
  id: Doc;
  url: string;
  text: string;
};

const DocumentLink: FunctionComponent<DocumentLinkProps> = props => {
  const { id, text, url } = props;
  const dispatch = useDispatch();

  const clickHandler = () => {
    dispatch(loadDocument(url, id));
  };

  return (
    <LinkWrapper id={id} testId='document-link' onClickHandler={clickHandler}>
      {text}
      {props.children}
    </LinkWrapper>
  );
};

export default DocumentLink;
